<template>
  <div>
    <!-- 来账白名单管理 -->
    <a-card title="来账白名单管理" style="margin: 20px">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>收款账号</span>
          <a-input v-model.trim="paramsData.accountNo" placeholder="请输入收款账号" allow-clear/>
        </div>
        <div class="item">
          <span>对方账号</span>
          <a-input v-model.trim="paramsData.oppAccountNo" placeholder="请输入对方账号" allow-clear/>
        </div>
        <div class="item">
          <span>对方户名</span>
          <a-input v-model.trim="paramsData.oppAccountName" placeholder="请输入对方户名" allow-clear/>
        </div>
        <div class="item">
          <span>审批状态</span>
          <a-select v-model="paramsData.approveStatus" placeholder="请选择审批状态" allow-clear style="width: 200px">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for="(type, value) in  accountDict.approveStatusMap" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="item">
          <span>推送状态</span>
          <a-select v-model="paramsData.pushStatus" placeholder="请选择推送状态" allow-clear style="width: 200px">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for="(type, value) in  accountDict.pushStatusMap" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="showAddModal">新增白名单</a-button>
          <a-button type="primary" @click="handleQuery">刷新</a-button>
          <a-button type="primary" @click="handlePushToBank" :loading="pushLoading" :disabled="!hasSelection">
            推送银行
          </a-button>
        </div>
        <div class="tableBody">
          <a-table :columns="columns" :data-source="tableData" :pagination="false" :row-key="record => record.id"
                   :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :row-class-name="getRowClassName">


            <!-- 附件列 -->
            <template slot="fileNo" slot-scope="text">
              <file-preview v-if="text" :file-no="text "/>
              <span v-else>无附件</span>
            </template>

            <!-- 操作列 -->
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <!-- 查看详情 -->
                <a-button icon="eye" type="link" @click="showDetailModal(record)">
                  详情
                </a-button>

                <!-- 修改按钮（仅审批中状态显示） -->
                <a-button v-if="record.approveStatus === '00'" icon="edit" type="link" @click="showEditModal(record)">
                  修改
                </a-button>

                <!-- 审批按钮（仅审批中状态显示，需要审批权限） -->
                <a-button v-if="record.approveStatus === '00' && hasApprovePermission" icon="check-circle" type="link" style="color: #52c41a;"
                          @click="showApproveModal(record)">
                  审批
                </a-button>

                <!-- 推送银行按钮（仅审批通过且未推送状态显示） -->
                <a-button v-if="record.approveStatus === '01' && (record.pushStatus === '00'||record.pushStatus === '02')" icon="upload" type="link"
                          style="color: #1890ff;"
                          @click="handleSinglePush(record)">
                  推送
                </a-button>

                <!-- 删除按钮（仅审批中或驳回状态显示） -->
                <a-button v-if="['00', '02'].includes(record.approveStatus)" icon="delete" type="link" style="color: #ff4d4f;" @click="deleteRecord(record)">
                  删除
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="pagination-wrapper">
        <LcfsPagination :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize" :total="pagination.total" @change="getTableData"
        />
      </div>
    </a-card>

    <!-- 新增/修改弹窗 -->
    <a-modal v-model="formModal.visible" :title="formModal.title" @ok="handleFormSubmit" @cancel="handleFormCancel" :confirm-loading="formModal.loading"
             :width="600">
      <a-form-model ref="formRef" :model="formData" :rules="formRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" :colon="false" label-align="left">
        <a-form-model-item label="收款账号" prop="accountNo">

          <WalletChooseDialog v-model="formData.accountName" :account-class="'0'" :open-account-class="true" @chooseDone="onMerchantWalletChosen"/>
          <div v-if="formData.accountName" style="margin-top: 8px;">
            <WalletInfo :account-name="formData.accountName" :account-no="formData.accountNo"/>
          </div>
        </a-form-model-item>
        <a-form-model-item label="对方账号" prop="oppAccountNo">
          <a-input
              v-model.trim="formData.oppAccountNo"
              placeholder="请输入对方账号"
              allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="对方户名" prop="oppAccountName">
          <a-input
              v-model.trim="formData.oppAccountName"
              placeholder="请输入对方户名"
              allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="附件地址">
          <a-upload name="file" :multiple="false" :action="uploadAction" :headers="uploadHeaders" @change="handleUploadChange">
            <a-button>
              <a-icon type="upload"/>
              上传附件
            </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="note">
          <a-textarea v-model.trim="formData.note" placeholder="请输入备注" allow-clear :rows="3"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 详情弹窗 -->
    <a-modal v-model="detailModal.visible" title="来账白名单详情" @cancel="detailModal.visible = false" :footer="null" :width="600">
      <a-descriptions :column="1" bordered>


        <a-descriptions-item label="部门ID">
          <DeptInfo :dept-id="detailData.departmentId"/>
        </a-descriptions-item>
        <a-descriptions-item label="收款账号">
          <WalletInfo :accountNo="detailData.accountNo" :accountName="detailData.accountName" :showAccountName="true"/>
        </a-descriptions-item>

        <a-descriptions-item label="对方账号">
          {{ detailData.oppAccountNo || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="对方户名">
          {{ detailData.oppAccountName }}
        </a-descriptions-item>
        <a-descriptions-item label="附件编号">

          <file-preview v-if="detailData.fileNo" :file-no="detailData?.fileNo "/>
          <span v-else>无附件</span>
        </a-descriptions-item>
        <a-descriptions-item label="备注">
          {{ detailData.note || '无' }}
        </a-descriptions-item>
        <a-descriptions-item label="审批状态">
          <a-badge
              :color="getApproveStatus(detailData.approveStatus).color"
              :text="getApproveStatus(detailData.approveStatus).label"
          />
        </a-descriptions-item>
        <a-descriptions-item label="推送银行状态">
          <a-badge
              :color="getPushStatus(detailData.approveStatus).color"
              :text="getPushStatus(detailData.approveStatus).label"
          />
        </a-descriptions-item>
        <a-descriptions-item v-if="detailData.approveUser" label="审批人">
          {{ detailData.approveUser }}
        </a-descriptions-item>
        <a-descriptions-item v-if="detailData.approveTime" label="审批时间">
          {{ formatDateTime(detailData.approveTime) }}
        </a-descriptions-item>
        <a-descriptions-item v-if="detailData.approveRemark" label="审批意见">
          {{ detailData.approveRemark }}
        </a-descriptions-item>
        <a-descriptions-item v-if="detailData.pushTime" label="推送时间">
          {{ formatDateTime(detailData.pushTime) }}
        </a-descriptions-item>
        <a-descriptions-item v-if="detailData.pushRemark" label="推送备注">
          {{ detailData.pushRemark }}
        </a-descriptions-item>
        <a-descriptions-item label="创建人">
          {{ detailData.creater || '未知' }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">
          {{ formatDateTime(detailData.createTime) }}
        </a-descriptions-item>
        <a-descriptions-item label="更新人">
          {{ detailData.updater || '未知' }}
        </a-descriptions-item>
        <a-descriptions-item label="更新时间">
          {{ formatDateTime(detailData.updateTime) }}
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>

    <!-- 审批弹窗 -->
    <a-modal v-model="approveModal.visible" :title="`审批操作 - ${approveModal.currentRecord?.oppAccountName || ''}`" @ok="handleApproveSubmit"
             @cancel="approveModal.visible = false" :confirm-loading="approveModal.loading" :width="500">
      <a-form-model ref="approveFormRef" :model="approveFormData" :rules="approveFormRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" :colon="false"
                    label-align="left">
        <a-form-model-item label="收款账号">
          <span style="color: #666">{{ approveModal.currentRecord?.accountNo || '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="对方账号">
          <span style="color: #666">{{ approveModal.currentRecord?.oppAccountNo || '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="对方户名">
          <span style="color: #666">{{ approveModal.currentRecord?.oppAccountName || '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="对方户名">
          <file-preview :file-no="approveModal.currentRecord?.fileNo "/>
        </a-form-model-item>

        <a-form-model-item label="审批结果" prop="approveStatus">
          <a-radio-group v-model="approveFormData.approveStatus">
            <a-radio value="01">通过</a-radio>
            <a-radio value="02">驳回</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审批意见" prop="approveRemark" :required="approveFormData.approveStatus === '02'">
          <a-textarea v-model.trim="approveFormData.approveRemark" :placeholder="approveFormData.approveStatus === '02' ? '请输入驳回原因' : '请输入审批意见'"
                      :rows="4" :max-length="500"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 推送确认弹窗 -->
    <a-modal v-model="pushModal.visible" title="推送银行确认" @ok="handlePushConfirm" @cancel="pushModal.visible = false" :confirm-loading="pushModal.loading">
      <div v-if="pushModal.type === 'batch'">
        <p>确认要将选中的 {{ selectedRowKeys.length }} 条记录推送到银行吗？</p>
        <p style="color: #faad14">只有审批通过且未推送的记录才会被推送。</p>
      </div>
      <div v-else>
        <p>确认要将该记录推送到银行吗？</p>
        <p><strong>收款账号：</strong>{{ pushModal.currentRecord?.accountNo || '' }}</p>
        <p><strong>对方户名：</strong>{{ pushModal.currentRecord?.oppAccountName || '' }}</p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import {accountDict} from "@/utils/bizDict/accountDict";
import urlConfig from "@/utils/urlConfig";
import WalletInfo from "@/view/components/WalletInfo.vue";
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import {handleChannelNo} from "@/utils/commonMethods";
import DeptInfo from "@/view/components/DeptInfo.vue";
import FilePreview from "@/view/components/FilePreview.vue";

const getToken = () => sessionStorage.getItem('token')
export default {
  name: 'CustAccIncomingWhiteList',
  components: {FilePreview, WalletChooseDialog, WalletInfo, LcfsPagination, handleChannelNo, DeptInfo},
  data() {
    return {
      // 分页配置
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },

      // 查询参数
      paramsData: {
        channelNo: "",
        appNo: "",
        accountNo: "",
        oppAccountNo: "",
        oppAccountName: "",
        approveStatus: "",
        pushStatus: ""
      },

      // 表格数据
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],

      // 表单弹窗
      formModal: {
        visible: false,
        title: "新增来账白名单",
        mode: "add", // add/edit
        loading: false
      },

      // 表单数据
      formData: {
        id: null,
        accountNo: "",
        oppAccountNo: "",
        oppAccountName: "",
        fileNo: "",
        note: ""
      },

      // 表单验证规则
      formRules: {
        accountNo: [
          {required: true, message: '请输入收款账号', trigger: 'blur'},
          {max: 32, message: '长度不能超过32个字符', trigger: 'blur'}
        ],
        oppAccountName: [
          {required: true, message: '请输入对方户名', trigger: 'blur'},
          {max: 128, message: '长度不能超过128个字符', trigger: 'blur'}
        ]
      },

      // 文件上传
      fileList: [],
      uploadAction: urlConfig.busiURL + '/file/manager/upload', // 实际文件上传地址
      uploadHeaders: {
        token: getToken(),
      },

      // 详情弹窗
      detailModal: {
        visible: false
      },
      detailData: {},

      // 审批弹窗
      approveModal: {
        visible: false,
        loading: false,
        currentRecord: null
      },
      approveFormData: {
        approveStatus: "01",
        approveRemark: ""
      },
      approveFormRules: {
        approveStatus: [
          {required: true, message: '请选择审批结果', trigger: 'change'}
        ],
        approveRemark: [
          {required: true, message: '请输入审批意见', trigger: 'blur'},
          {max: 500, message: '长度不能超过500个字符', trigger: 'blur'}
        ]
      },

      // 推送弹窗
      pushModal: {
        visible: false,
        loading: false,
        type: 'single', // single/batch
        currentRecord: null
      },
      pushLoading: false,

      // 表格列定义
      columns: [
        {
          title: "No",
          customRender: (text, record, index) =>
              `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 40
        },
        {
          title: '机构',
          dataIndex: 'departmentId',
          align: 'center',
          ellipsis: true,
          width: 120,
          customRender: (text) => {
            return <DeptInfo dept-id={text}/>
          },
        },
        {
          title: '渠道',
          dataIndex: 'channelNo',
          align: 'center',
          ellipsis: true,
          width: 80,
          customRender: (text) => {
            return handleChannelNo(JSON.parse(this.$session.getItem('coreCompanyList')), text, '1')
          },
        },
        {
          title: "收款人",
          dataIndex: "accountName",
          align: "center",
          width: 120,
          ellipsis: true,
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.accountNo} accountName={record.accountName} showAccountName={true}/>);
          }
        },
        {
          title: "对方账号",
          dataIndex: "oppAccountNo",
          align: "center",
          width: 100,
          ellipsis: true,
        },
        {
          title: "对方户名",
          dataIndex: "oppAccountName",
          align: "center",
          width: 120,
          ellipsis: true,
        },
        {
          title: "附件",
          dataIndex: "fileNo",
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'fileNo'}
        },
        {
          title: "审批状态",
          dataIndex: "approveStatus",
          align: "center",
          width: 60,
          customRender: (text) => {
            return <a-tag color={this.getApproveStatus(text).color}>{this.getApproveStatus(text).label}</a-tag>
          },
        },
        {
          title: "推送状态",
          dataIndex: "pushStatus",
          align: "center",
          width: 60,
          customRender: (text) => {
            return <a-tag color={this.getPushStatus(text).color}>{this.getPushStatus(text).label}</a-tag>
          },
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          align: "center",
          width: 100,
          customRender: (text) => this.formatDateTime(text)
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ],

      // 权限控制（实际项目中应该从权限系统获取）
      hasApprovePermission: true
    };
  },
  computed: {
    accountDict() {
      return accountDict;
    },
    hasSelection() {
      return this.selectedRowKeys.length > 0;
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    onMerchantWalletChosen(wallet) {
      this.formData.accountNo = wallet.accountNo;
      this.formData.accountName = wallet.accountName;
      // 触发校验
      this.$nextTick(() => {
        this.$refs.merchantForm && this.$refs.merchantForm.validateField('accountNo');
      });
    },

    // 状态配置方法
    getApproveStatus(status) {
      return accountDict.approveStatusMap[status] || accountDict.approveStatusMap.default;
    },

    getPushStatus(status) {
      return accountDict.pushStatusMap[status] || accountDict.pushStatusMap.default;
    },

    // 获取表格数据
    async getTableData() {
      try {
        const params = {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          ...this.paramsData
        };
        const res = await this.api.accIncomeWhiteListPageQueryApi(params);
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    // 查询
    handleQuery() {
      this.pagination.pageNo = 1;
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.paramsData = {
        channelNo: "",
        appNo: "",
        accountNo: "",
        oppAccountNo: "",
        oppAccountName: "",
        approveStatus: "",
        pushStatus: ""
      };
      this.pagination.pageNo = 1;
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.getTableData();
    },

    // 行选择变化
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },

    // 显示新增弹窗
    showAddModal() {
      this.formModal.mode = 'add';
      this.formModal.title = '新增来账白名单';
      this.formModal.visible = true;

      this.$nextTick(() => {
        this.resetFormData();
        this.$refs.formRef && this.$refs.formRef.resetFields();
        this.fileList = [];
      });
    },

    // 显示编辑弹窗
    async showEditModal(record) {
      // 只有审批中状态可以编辑
      if (record.approveStatus !== '00') {
        message.warning('只有审批中状态的记录可以编辑');
        return;
      }

      try {
        // 获取详情
        const res = await this.api.accIncomeWhiteListDetailsApi(record.id);
        if (res.code === 200) {
          this.formModal.mode = 'edit';
          this.formModal.title = '编辑来账白名单';
          this.formModal.visible = true;

          this.$nextTick(() => {
            this.formData = {
              id: res.data.id,
              accountNo: res.data.accountNo || '',
              accountName: res.data.accountName || '',
              oppAccountNo: res.data.oppAccountNo || '',
              oppAccountName: res.data.oppAccountName || '',
              fileNo: res.data.fileNo || '',
              note: res.data.note || ''
            };

            if (res.data.fileNo) {
              this.fileList = [{
                uid: '-1',
                name: '附件',
                status: 'done',
                url: res.data.fileNo
              }];
            }
          });
        } else {
          message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        message.error("获取详情失败");
      }
    },

    // 重置表单数据
    resetFormData() {
      this.formData = {
        id: null,
        accountNo: "",
        oppAccountNo: "",
        oppAccountName: "",
        fileNo: "",
        note: ""
      };
    },

    // 处理表单提交（新增/修改）
    async handleFormSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          message.error('请填写完整信息');
          return;
        }

        this.formModal.loading = true;
        try {
          let res;
          if (this.formModal.mode === 'add') {
            res = await this.api.accIncomeWhiteListAddApi(this.formData);
          } else {
            res = await this.api.accIncomeWhiteListEditApi(this.formData);
          }

          if (res.code === 200) {
            this.fileList=[]
            message.success(this.formModal.mode === 'add' ? '新增成功' : '修改成功');
            this.formModal.visible = false;
            this.getTableData();
          } else {
            message.error(res.info || (this.formModal.mode === 'add' ? '新增失败' : '修改失败'));
          }
        } catch (error) {
          console.error("操作失败:", error);
          message.error(this.formModal.mode === 'add' ? '新增失败' : '修改失败');
        } finally {
          this.formModal.loading = false;
        }
      });
    },

    // 处理表单取消
    handleFormCancel() {
      this.formModal.visible = false;
      this.resetFormData();
      this.fileList = [];
    },

    // 文件上传前处理
    beforeUpload(file) {
      // 限制文件大小和类型
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error('文件大小不能超过10MB');
        return false;
      }
      return true;
    },

    handleUploadChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.formData.fileNo = info.file.response.data.file_no;
        this.$message.success(`${info.file.name} 上传成功`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },

    // 清除文件
    clearFile() {
      this.formData.fileNo = '';
      this.fileList = [];
    },

    // 查看附件
    handleViewFile(fileNo) {
      // 这里可以根据实际的文件服务地址打开附件
      window.open(`/api/file/download?fileNo=${fileNo}`, '_blank');
    },

    // 显示详情弹窗
    async showDetailModal(record) {
      try {
        const res = await this.api.accIncomeWhiteListDetailsApi(record.id);
        if (res.code === 200) {
          this.detailData = res.data;
          this.detailModal.visible = true;
        } else {
          message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        message.error("获取详情失败");
      }
    },

    // 显示审批弹窗
    showApproveModal(record) {
      // 只有审批中状态可以审批
      if (record.approveStatus !== '00') {
        message.warning('只有审批中状态的记录可以审批');
        return;
      }

      this.approveModal.currentRecord = record;
      this.approveModal.visible = true;

      this.$nextTick(() => {
        this.approveFormData = {
          approveStatus: "01",
          approveRemark: ""
        };
        this.$refs.approveFormRef && this.$refs.approveFormRef.resetFields();
      });
    },

    // 处理审批提交
    async handleApproveSubmit() {
      this.$refs.approveFormRef.validate(async (valid) => {
        if (!valid) {
          message.error('请填写完整信息');
          return;
        }

        // 如果审批驳回，必须填写原因
        if (this.approveFormData.approveStatus === '02' && !this.approveFormData.approveRemark.trim()) {
          message.error('请填写驳回原因');
          return;
        }

        this.approveModal.loading = true;
        try {
          const params = {
            id: this.approveModal.currentRecord.id,
            approveStatus: this.approveFormData.approveStatus,
            approveRemark: this.approveFormData.approveRemark
          };

          const res = await this.api.accIncomeWhiteListApproveApi(params);
          if (res.code === 200) {
            message.success('审批操作成功');
            this.approveModal.visible = false;
            this.getTableData();
          } else {
            message.error(res.info || "审批操作失败");
          }
        } catch (error) {
          console.error("审批操作失败:", error);
          message.error("审批操作失败");
        } finally {
          this.approveModal.loading = false;
        }
      });
    },

    // 删除记录
    deleteRecord(record) {
      // 只有审批中或驳回状态可以删除
      if (!['00', '02'].includes(record.approveStatus)) {
        message.warning('只有审批中或驳回状态的记录可以删除');
        return;
      }

      this.$confirm({
        title: `确认删除来账白名单记录吗？`,
        content: `对方户名: ${record.oppAccountName}`,
        okText: '确认删除',
        cancelText: '取消',
        okType: 'danger',
        onOk: async () => {
          try {
            const res = await this.api.accIncomeWhiteListDelApi(record.id);
            if (res.code === 200) {
              message.success("删除成功");
              this.getTableData();
            } else {
              message.warning(res.info || "删除失败");
            }
          } catch (error) {
            console.error("删除失败:", error);
            message.error("删除失败");
          }
        }
      });
    },

    // 批量推送银行
    handlePushToBank() {
      // 筛选出可以推送的记录（审批通过且未推送）
      const pushableRecords = this.selectedRows.filter(record =>
          record.approveStatus === '01' && (record.pushStatus === '00' || record.pushStatus === '02')
      );

      if (pushableRecords.length === 0) {
        message.warning('选中的记录中没有可以推送的记录（需要审批通过且未推送或推送失败）');
        return;
      }

      this.pushModal.type = 'batch';
      this.pushModal.visible = true;
    },

    // 单个推送
    handleSinglePush(record) {
      // 只有审批通过且未推送状态可以推送
      if (!(record.approveStatus == '01' && record.pushStatus !== '01')) {
        message.warning('只有审批通过且未推送或推送失败的记录可以推送');
        return;
      }

      this.pushModal.type = 'single';
      this.pushModal.currentRecord = record;
      this.pushModal.visible = true;
    },

    // 确认推送
    async handlePushConfirm() {
      this.pushModal.loading = true;
      try {

        let ids;
        if (this.pushModal.type === 'batch') {
          ids = this.selectedRows.filter(record => record.approveStatus === '01' && (record.pushStatus === '00' || record.pushStatus === '02')).map(record => record.id);
        } else {
          ids = [this.pushModal.currentRecord.id];
        }
        if (ids.length === 0) {
          message.warning('没有符合条件的记录可以推送');
          return;
        }

        // 批量推送接口（需要根据实际情况调整）
        const res = await this.api.accIncomeWhiteListPushToBankBatchApi(ids);

        if (res.code === 200) {
          message.success('推送成功');
          this.pushModal.visible = false;
          this.getTableData();
        } else {
          message.warning(res.info || "推送失败");
          this.pushModal.loading = false;
        }
      } catch (error) {
        console.error("推送失败:", error);
        message.error("推送失败");
        this.pushModal.loading = false;
      }
    },

    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return '';
      return new Date(dateTime).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '-');
    },

    // 获取行样式
    getRowClassName(record) {
      if (record.approveStatus === '01' && record.pushStatus === '00') {
        return 'success-row'; // 审批通过且未推送
      } else if (record.approveStatus === '01' && record.pushStatus === '01') {
        return 'push-success-row'; // 已推送成功
      }
      return '';
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
      min-width: 60px;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-radius: 0 0 6px 6px;
}

// 行样式
/deep/ .success-row {
  background-color: #f6ffed;
}

/deep/ .push-success-row {
  background-color: #e6f7ff;
}

// 表格操作列按钮样式
/deep/ .ant-btn-link {
  padding: 0 4px;
}
</style>